/**
 * Конфигурация фронта с двумя слоями.
 *
 * 1. Runtime: `window.__ENV__` — его пишет entrypoint контейнера (docker/40-env.sh) из переменных
 *    окружения `VUE_APP_*` в `env.js`, который index.html подключает до бандла. Так один образ
 *    работает на стейдже и на любом временном стенде: адрес API задаётся в манифесте деплоя,
 *    а не запекается при сборке.
 * 2. Build-time: `process.env.VUE_APP_*` — что было в окружении `vue-cli-service build`
 *    (Dockerfile `ARG`, `.env`). Остаётся fallback'ом и единственным источником в `npm run serve`,
 *    где `public/env.js` пустой.
 *
 * Пустая строка в любом слое считается «не задано».
 */
const runtimeEnv = (typeof window !== 'undefined' && window.__ENV__) || {};

// Vue CLI подменяет `process.env` целиком объектом с VUE_APP_*-ключами, поэтому доступ по
// вычисляемому ключу работает.
const buildEnv = process.env;

export function env(key, fallback) {
    const runtime = runtimeEnv[key];
    if (runtime !== undefined && runtime !== null && runtime !== '') {
        return runtime;
    }
    const build = buildEnv[key];
    if (build !== undefined && build !== null && build !== '') {
        return build;
    }
    return fallback;
}
